import React from "react";
import { styled } from "@mui/material/styles";
import { Select, MenuItem } from "@mui/material";
import { EllipsisWithTooltip } from "../EllipsisWithTooltip";

interface HeaderSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  label: string;
}

const HeaderSelect: React.FC<HeaderSelectProps> = ({ value, onChange, options, label }) => (
  <StyledSelect
    value={value}
    onChange={(e) => onChange(String(e.target.value))}
    renderValue={() => <EllipsisWithTooltip placement="top">{label}</EllipsisWithTooltip>}
  >
    <MenuItem value="none" sx={{ fontSize: "0.75rem" }}>
      <em>None</em>
    </MenuItem>
    {options.map((option) => (
      <MenuItem key={`header-${option}`} value={option}>
        {option}
      </MenuItem>
    ))}
  </StyledSelect>
);

const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiSelect-select": {
    padding: theme.spacing(1),
    fontSize: "0.9rem",
    fontWeight: "bold",
    backgroundColor: "transparent",
    width: "175px",
    maxWidth: "175px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

export default HeaderSelect;
